module.exports = __webpack_public_path__ + "media/common/images/innogy_style/work-style-485f97d2a786e8cf9ceae3e6ff7e4e7a.svg";